import { IDeleteChecklistServicoAmbienteUseCase } from "../../../presentation/useCases/delete/delete_checklist_servico_ambiente_use_case";
import { IObrasRepository } from "../../repositories/obras_repository";

/**
 * DeleteChecklistServicoAmbienteUseCase
 */

export class DeleteChecklistServicoAmbienteUseCase implements IDeleteChecklistServicoAmbienteUseCase {
  constructor(private readonly repository: IObrasRepository) { }

  async execute(idChecklistServicoAmbiente: number): Promise<void> {
    await this.repository.deleteChecklistServicoAmbienteById(idChecklistServicoAmbiente);

  }
}
